<div class="full-width-image-section car-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1 id="header">{{ 'INSURANCE.CAR.COMPONENTS.INDEX.CALCULATE_AND_BUY' | translate }}</h1>
                </div>
            </div>

            <p class="home-insurance-text">
                NEXT er blevet til easySure, men du kan stadig vælge de samme gode forsikringer, faktisk med lidt bedre dækning. Ingen binding og ingen skjulte gebyrer.
            </p>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-12 text-center">
            <br />
            <br />
            <a href="https://ssp.easysure.dk/sales-journey/carLiability/?kpcid=20000131" class="btn btn-success calculate-btn">Beregn hos easySure</a>
            <br />
            <br />
        </div>
    </div>
</div>

<br />
<br />

<div class="container" *ngIf="!useNewCarProduct">
    <div class="row">
        <div class="col-sm-12">
            <div class="points-text-container">
                <ng-template #popTemplate2>
                    <div [innerHtml]="'INSURANCE.CAR.COMPONENTS.INDEX.FREE_CLAIM_TEXT' | translate"></div>
                </ng-template>
                <div class="col-xs-12 col-md-3 col-md-offset-2 hidden-xs" [tooltip]="popTemplate2">
                    <i class="nf nf-checkmark-icon-v3"></i>
                    <h3>{{ 'INSURANCE.CAR.COMPONENTS.INDEX.FREE_CLAIM_TITLE' | translate | uppercase }}</h3>
                </div>
                <ng-template #pop2Modal>
                    <div class="tooltip-modal">
                        {{ 'INSURANCE.CAR.COMPONENTS.INDEX.FREE_CLAIM_TEXT' | translate }}
                        <button class="btn btn-success closeConfirmRemoveModal" (click)="closeModal()">{{ 'SHARED.OK' | translate }}</button>
                    </div>
                </ng-template>
                <div class="col-xs-12 col-md-3 col-md-offset-2 visible-xs" (click)="openModal(pop2Modal)">
                    <i class="nf nf-checkmark-icon-v3 hand"></i>
                    <h3>{{ 'INSURANCE.CAR.COMPONENTS.INDEX.FREE_CLAIM_TITLE' | translate | uppercase }}</h3>
                </div>

                <ng-template #popTemplate3>
                    <div [innerHtml]="'INSURANCE.CAR.COMPONENTS.INDEX.GLASS_TEXT' | translate"></div>
                </ng-template>
                <div class="col-xs-12 col-md-6 hidden-xs" [tooltip]="popTemplate3">
                    <i class="nf nf-checkmark-icon-v3"></i>
                    <h3>{{ 'INSURANCE.CAR.COMPONENTS.INDEX.GLASS_TITLE' | translate | uppercase }}</h3>
                </div>
                <ng-template #pop3Modal>
                    <div class="tooltip-modal">
                        {{ 'INSURANCE.CAR.COMPONENTS.INDEX.GLASS_TEXT' | translate }}
                        <button class="btn btn-success closeConfirmRemoveModal" (click)="closeModal()">{{ 'SHARED.OK' | translate }}</button>
                    </div>
                </ng-template>
                <div class="col-xs-12 col-md-3 col-md-offset-2 visible-xs" (click)="openModal(pop3Modal)">
                    <i class="nf nf-checkmark-icon-v3 hand"></i>
                    <h3>{{ 'INSURANCE.CAR.COMPONENTS.INDEX.GLASS_TITLE' | translate | uppercase }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<trustpilot-carousel></trustpilot-carousel>
<div class="car-faq">
    <h2 class="text-center">{{ 'SHARED.FAQ.COMPONENTS.FAQ_ARTICLE.FAQ' | translate }}</h2>
    <next-faq [category]="'FAQ_CAR'"></next-faq>
</div>

<nicetoknow [pagecode]="'INSURANCE_CAR_NICETOKNOW'"></nicetoknow>

<next-footer></next-footer>
